import Map from './Map.vue';
export default Map;


// WEBPACK FOOTER //
// ./src/pages/event/map/index.js